module.exports = __webpack_public_path__ + "img/przelewy24_neg.8a3aa640.svg";